import { React, useState } from "react";
import { Checkbox, Row, Col, Flex, Modal, Input, Button } from "antd";
function ExportModal({ createTemplate }) {
  const [openResponsive, setOpenResponsive] = useState(false);
  const [modalSelectedValues, setModalSelectedValues] = useState([]);
  const [modalTemplateName, setModalTemplateName] = useState("");
  const onChange = (checkedValues) => {
    setModalSelectedValues(checkedValues);
    console.log(checkedValues);
  };
  return (
    <div className="create-template">
      <Flex vertical gap="middle" align="flex-start">
        <Button type="primary" onClick={() => setOpenResponsive(true)}>
          Create Template +
        </Button>
        <Modal
          title="Create a New Export Template"
          centered
          open={openResponsive}
          onOk={() => {
            createTemplate(
              modalTemplateName,
              setOpenResponsive,
              modalSelectedValues
            );
            setModalTemplateName("");
            setModalSelectedValues([]);
          }}
          onCancel={() => setOpenResponsive(false)}
          width={{
            xs: "90%",
            sm: "80%",
            md: "70%",
            lg: "60%",
            xl: "50%",
            xxl: "40%",
          }}
        >
          <Input
            placeholder="Enter Template Name"
            style={{
              textAlign: "left",
              direction: "ltr",
              marginBottom: "20px",
            }}
            value={modalTemplateName}
            onChange={(e) => setModalTemplateName(e.target.value)}
          />
          <Checkbox.Group
            style={{
              width: "100%",
            }}
            defaultValue={[]}
            value={modalSelectedValues}
            onChange={onChange}
          >
            <Row gutter={[16, 16]}>
              <Col span={8}>
                <Checkbox value="Date">Date</Checkbox>
              </Col>
              <Col span={8}>
                <Checkbox value="Payroll">Payroll</Checkbox>
              </Col>
              <Col span={8}>
                <Checkbox value="Vendor">Vendor</Checkbox>
              </Col>
              <Col span={8}>
                <Checkbox value="Role">Role</Checkbox>
              </Col>
              <Col span={8}>
                <Checkbox value="Candidate Name">Candidate Name</Checkbox>
              </Col>
              <Col span={8}>
                <Checkbox value="Contact No.">Contact No.</Checkbox>
              </Col>
              <Col span={8}>
                <Checkbox value="Email">Email</Checkbox>
              </Col>
              <Col span={8}>
                <Checkbox value="Total Work Exp">Total Work Exp</Checkbox>
              </Col>
              <Col span={8}>
                <Checkbox value="Current Location">Current Location</Checkbox>
              </Col>
              <Col span={8}>
                <Checkbox value="Preferred Location">
                  Preferred Location
                </Checkbox>
              </Col>
              <Col span={8}>
                <Checkbox value="Highest Qualification">
                  Highest Qualification
                </Checkbox>
              </Col>
              <Col span={8}>
                <Checkbox value="Current Company">Current Company</Checkbox>
              </Col>
              <Col span={8}>
                <Checkbox value="Current Designation">
                  Current Designation
                </Checkbox>
              </Col>
              <Col span={8}>
                <Checkbox value="Current Salary">Current Salary</Checkbox>
              </Col>
              <Col span={8}>
                <Checkbox value="Expected Salary">Expected Salary</Checkbox>
              </Col>
              <Col span={8}>
                <Checkbox value="Notice Period">Notice Period</Checkbox>
              </Col>
              <Col span={8}>
                <Checkbox value="Status">Status</Checkbox>
              </Col>
            </Row>
          </Checkbox.Group>
        </Modal>
      </Flex>
    </div>
  );
}

export default ExportModal;
